$(document).ready(function() {
    let formatMoney = function(value) {
        return '$' + parseFloat(value.toFixed(2)).toLocaleString('en-US', {minimumFractionDigits: 2})
    }
    let mortgageForm = document.querySelector('[mortgage-calculator-form]');
    if (mortgageForm) {
        mortgageForm.querySelector('[calculate]').addEventListener('click', function() {
            let fields = mortgageForm.querySelector('[mortgage-fields]');
            let results = mortgageForm.querySelector('[mortgage-results]');
            let errorDisplay = results.querySelector('[error]');

            results.querySelector('#loan').textContent = '';
            results.querySelector('#interest-only-per-annum').textContent = '';
            results.querySelector('#p-and-i-per-term').textContent = '';
            results.querySelector('#interest-payable-per-term').textContent = '';
            results.querySelector('#total-interest-payable').textContent = '';
            results.querySelector('#total-loan').textContent = '';
            
            let rate = parseFloat(fields.querySelector('[name="interest-rate"]').value || 0);
            let periods = parseInt(fields.querySelector('[name="payment-frequency"]').value || 0);
            rate = rate / 100 / periods;
            let value = parseInt(fields.querySelector('[name="principal"]').value || 0);
            let years = parseFloat(fields.querySelector('[name="years"]').value || 0);
            let paymentCount = periods * years;

            if (!rate || !periods || !value || !years) {
                errorDisplay.textContent = 'Please fill in all fields and try again.';
                errorDisplay.classList.remove('d-none');
                return false;
            } else {
                errorDisplay.textContent = '';
                errorDisplay.classList.add('d-none');
            }

            let payment = value * (rate / (1 - (1 + rate) ** -paymentCount));
            let interest = rate * value;
            let interestPerAnnum = interest * periods;
            let totalLoan = payment * paymentCount;
            let totalInterest = totalLoan - value;
            
            results.querySelector('#loan').textContent = formatMoney(value);
            results.querySelector('#interest-only-per-annum').textContent = formatMoney(interestPerAnnum) + ' per annum';
            results.querySelector('#p-and-i-per-term').textContent = formatMoney(payment) + ' per term';
            results.querySelector('#interest-payable-per-term').textContent = formatMoney(interest) + ' per term';
            results.querySelector('#total-interest-payable').textContent = formatMoney(totalInterest);
            results.querySelector('#total-loan').textContent = formatMoney(totalLoan);
        });
    }
});